import { Dropdown } from 'primereact/dropdown'

import { cap } from '../../State'
import { translations } from '../../translations'
import { FieldWrapper } from './FieldWrapper'

const language = cap.language.state || 'IT'
const t = translations[language]

export const SelectField = ({
  id,
  label,
  value,
  onChange,
  onBlur,
  options = [],
  required,
  disabled,
  helper,
  error,
  diffStatus,
  ai = false,
  placeholder = t.seleziona,
  showClear = true
}) => (
  <FieldWrapper
    id={id}
    label={label}
    required={required}
    helper={helper}
    error={error}
    diffStatus={diffStatus}
    ai={ai}
    disabled={disabled}
  >
    <Dropdown
      inputId={id}
      value={value ?? ''}
      onChange={(e) => onChange?.(e.value ?? '')}
      onBlur={onBlur}
      options={options}
      optionLabel="label"
      optionValue="value"
      disabled={disabled}
      placeholder={placeholder}
      showClear={showClear && !!value}
      aria-invalid={error ? 'true' : 'false'}
      className={error ? 'p-invalid' : ''}
    />
  </FieldWrapper>
)
